import React from 'react';

import styled from '@emotion/styled';

import PrimaryButton from '../../components/Button/PrimaryButton';
import { FullTextLogo } from '../../components/CompanyLogo';
import HamburgerIcon from '../../components/Icons/HamburgerIcon';
import { ExternalLink, NavLink } from '../../components/Link/Link';
import Nav from './Nav';

interface IHeader {
  open: boolean;
  toggleNav: (...arg: any) => void;
}

const Header: React.FC<IHeader> = ({ open, toggleNav }) => {
  return (
    <Container>
      <NavLink to="/">{!open && <FullTextLogo className="header" />}</NavLink>
      <Nav />
      <HamburgerIconContainer onClick={() => toggleNav()}>
        <HamburgerIcon />
      </HamburgerIconContainer>
      <ExternalLink
        to="https://darum.ng/contact-us"
        className="header_nav__mobile"
      >
        <PrimaryButton>Contact Us</PrimaryButton>
      </ExternalLink>
    </Container>
  );
};

const Container = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 1.25rem 6.75rem;

  @media (max-width: 480px) {
    /* border: 2px solid red; */
    padding: 1rem;
  }
`;

const HamburgerIconContainer = styled.div`
  display: None;
  @media (max-width: 480px) {
    display: block;
    cursor: pointer;
  }
`;

export default Header;
